import React, { ChangeEvent, useCallback, useEffect, useState } from 'react';
import { InputForm } from 'src/components/common/form/input/InputForm';
import { useKSK2021_R01Store } from './Store_KSK2021_R01';
import { inputFormHeightOption } from 'src/components/common/common';
import { InfoCodeSearchFieldConfig, InfoFieldHandlers } from 'src/types/info-form';
import { getProductWorkList } from 'src/apis/productWorkApi';
import useUiuxStore from 'src/store/useUiuxStore';
import { useInfoFormEvents } from 'src/hooks/useInfoFormEvents';
import { CodeForm } from 'src/components/common/form/CodeForm';

interface Props {
	setSearchTrigger: (value: boolean) => void;
	handleChange: (e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>) => void;
	handleFetchLotList: () => void;

	getProductWorkFieldHandlers: (fieldName: string) => InfoFieldHandlers;
}

export const InputForm_KSK2021_R01 = (props: Props) => {

	const {
		setSearchTrigger,
		handleChange,
		handleFetchLotList,
		getProductWorkFieldHandlers,
	} = props;

	const {
		editKSK2021_R01,
		setEditKSK2021_R01,
	} = useKSK2021_R01Store();

	return (
        <div className="w-full flex flex-wrap items-center gap-[0px]">
			<CodeForm
				label="공정지시"
				value={editKSK2021_R01?.productWorkNo || ""}
				custNmValue={editKSK2021_R01?.productWorkNm || ""}
				editable={true}
				custNmInputless={true}
				name="productWorkNo"
				handleChange={handleChange}
				onDoubleClick={(e) => {
					getProductWorkFieldHandlers('productWorkNo').onDoubleClick(e);
				}}
				onKeyDown={(e) => {
					getProductWorkFieldHandlers('productWorkNo').onEnterKeyDown(e);
				}}
				wrapperOption={{
					wrapperStyle: "w-[540px] min-w-[540px] mb-[4px]",
					titleStyle: "w-[150px] min-w-[150px] text-left",
					codeInputStyle: "w-[380px] min-w-[380px] " + inputFormHeightOption,
					custNmInputStyle: "w-[105px] min-w-[105px]"
				}}
			/>
            
            <button 
                // flex-shrink-0을 주어 버튼 크기가 찌그러지지 않도록 합니다.
                className={`text-white bg-blue-dark items-center justify-center px-[8px] py-[2px] rounded-[4px] w-[74px] mb-[4px] flex-shrink-0 ${inputFormHeightOption}`}
                onClick={() => {
					setSearchTrigger(true);
				}}
            >
                조회
            </button>
        </div>
    );
}